var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.file)?_c('div',{staticClass:"docs-page",attrs:{"id":"file-viewer"}},[_c('source-button',{attrs:{"path":_vm.file.path,"docs":_vm.docs}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})],1):_c('unknown-page',{staticClass:"docs-page",attrs:{"darkMode":_vm.darkMode}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4734cc58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/FileViewer.vue
// module id = null
// module chunks = 